import * as actionTypes from '../actions/actionTypes'
import { updateObject } from '../utility'

const initialState = {
  root: true,
  inside: "",
  bcSearch: "",
  unchangedCurrent: [],
  overallInfo: {
    a: {
      a01: ['a01a', 'a01b', 'a01c'],
      a02: ['a02a', 'a02b', 'a02c'],
      a03: ['a03a', 'a03b'],
      a04: ['a04a', 'a04b', 'a04c', 'a04d', 'a04e', 'a04f', 'a04g', 'a04h', 'a04i', 'a04j', 'a04k', 'a04l', 'a04m', 'a04n', 'a04o'],
      a05: ['a05a', 'a05b', 'a05c', 'a05d', 'a05e', 'a05f', 'a05g', 'a05h', 'a05i', 'a05j', 'a05k', 'a05l', 'a05m', 'a05n', 'a05o', 'a05p', 'a05q', 'a05r', 'a05s'],
      a06: ['a06a', 'a06b', 'a06c', 'a06d', 'a06e', 'a06f', 'a06g', 'a06h', 'a06i', 'a06j'],
      a07: ['a07a', 'a07b', 'a07c', 'a07d', 'a07e', 'a07f', 'a07g', 'a07h', 'a07i'],
      a08: ['a08a', 'a08b', 'a08c', 'a08d', 'a08e', 'a08f', 'a08g', 'a08h', 'a08i', 'a08j'],
      a09: ['a09a', 'a09b', 'a09c', 'a09d', 'a09e', 'a09f', 'a09g', 'a09h', 'a09i'],
      a10: ['a10a', 'a10b', 'a10c', 'a10d', 'a10e', 'a10f', 'a10g', 'a10h', 'a10i', 'a10j', 'a10k', 'a10l', 'a10m'],
      a11: ['a11a', 'a11b', 'a11c', 'a11d', 'a11e', 'a11f', 'a11g', 'a11h', 'a11i', 'a11j', 'a11k', 'a11l'],
      a12: ['a12a', 'a12b', 'a12m', 'a12c', 'a12d', 'a12e', 'a12f', 'a12g', 'a12h', 'a12i', 'a12j', 'a12k', 'a12l'],
      a13: ['a13a', 'a13b', 'a13c', 'a13d', 'a13e', 'a13f', 'a13g', 'a13h', 'a13i', 'a13j'],
      a14: ['a14a', 'a14b', 'a14c', 'a14d', 'a14e', 'a14f', 'a14g', 'a14h'],
      a15: ['a15a', 'a15b', 'a15c', 'a15d'],
      a16: ['a16a', 'a16b', 'a16c', 'a16d', 'a16e', 'a16f', 'a16g'],
      a17: ['a17a'],
      a18: ['a18a', 'a18b', 'a18c', 'a18d', 'a18e', 'a18f'],
      a19: ['a19a'],
      a20: ['a20a'],
      a21: ['a21a'],
      a22: ['a22a'],
    },
    b: {
      b001:[],b002:[],b003:[],b004:[],b005:[],b006:[],b007:[],b008:[],b009:[],b010:[],b011:[],b012:[],b013:[],b014:[],
      b015:[],b016:[],b017:[],b018:[],b019:[],b020:[],b021:[],b022:[],b023:[],b024:[],b025:[],b026:[],b027:[],b028:[],
      b029:[],b030:[],b031:[],b032:[],b033:[],b034:[],b035:[],b036:[],b037:[],b038:[],b039:[],b040:[],b041:[],b042:[],
      b043:[],b044:[],b045:[],b046:[],b047:[],b048:[],b049:[],b050:[],b051:[],b052:[],b053:[],b054:[],b055:[],b056:[],
      b057:[],b058:[],b059:[],b060:[],b061:[],b062:[],b063:[],b064:[],b065:[],b066:[],b067:[],b068:[],b069:[],b070:[],
      b071:[],b072:[],b073:[],b074:[],b075:[],b076:[],b077:[],b078:[],b079:[],b080:[],b081:[],b082:[],b083:[],b084:[],
      b085:[],b086:[],b087:[],b088:[],b089:[],b090:[],b091:[],b092:[],b093:[],b094:[],b095:[],b096:[],b097:[],b098:[],
      b099:[],b100:[],b101:[],b102:[],b103:[],b104:[],b105:[],b106:[],b107:[],b108:[],b109:[],b110:[],b111:[],b112:[],
      b113:[],b114:[],b115:[],b116:[],b117:[],b118:[],b119:[],b120:[],b121:[],b122:[],b123:[],b124:[],b125:[],b126:[],
      b127:[],b128:[],b129:[],b130:[],b131:[],b132:[],b133:[],b134:[],b135:[],b136:[],b137:[],b138:[],b139:[],b140:[],
      b141:[],b142:[],b143:[],b144:[],b145:[],b146:[],b147:[],b148:[],b149:[],b150:[],b151:[],b152:[],b153:[],b154:[],
      b155:[],b156:[],b157:[],b158:[],b159:[],b160:[],b161:[],b162:[],b163:[],b164:[],b165:[],b166:[],b167:[],b168:[],
      b169:[],b170:[],b171:[],b172:[],b173:[],b174:[],b175:[],b176:[],b177:[],b178:[],b179:[],b180:[],b181:[],b182:[],
      b183:[],b184:[],b185:[],b186:[],b187:[],b188:[],b189:[],b190:[],b191:[],b192:[],b193:[],b194:[],b195:[],b196:[],
      b197:[],b198:[],b199:[],b200:[],b201:[],b202:[],b203:[],b204:[],b205:[],b206:[],b207:[],b208:[],b209:[],b210:[],
      b211:[],b212:[],b213:[],b214:[],b215:[],b216:[],b217:[],b218:[],b219:[],b220:[],b221:[],b222:[],b223:[],b224:[],
      b225:[],b226:[],b227:[],b228:[],b229:[],b230:[],b231:[],b232:[],b233:[],b234:[],b235:[],b236:[],b237:[],b238:[],
      b239:[],b240:[],b241:[],b242:[],b243:[],b244:[],b245:[],b246:[],b247:[],b248:[],b249:[],b250:[],b251:[],b252:[],
      b253:[],b254:[],b255:[],b256:[],b257:[],b258:[],b259:[],b260:[],b261:[],b262:[],b263:[],b264:[],b265:[],b266:[],
      b267:[],b268:[],b269:[],b270:[],b271:[],b272:[],b273:[],b274:[],b275:[],b276:[],b277:[],b278:[],b279:[],b280:[],
      b281:[],b282:[],b283:[],b284:[],b285:[],b286:[],b287:[],b288:[],b289:[],b290:[],b291:[],b292:[],b293:[],b294:[],
      b295:[],b296:[],b297:[],b298:[],b299:[],b300:[],b301:[],b302:[]
    },
    c: {
      c001:[],c002:[],c003:[],c004:[],c005:[],c006:[],c007:[],c008:[],c009:[],c010:[],c011:[],c012:[],c013:[],c014:[],
      c015:[],c016:[],c017:[],c018:[],c019:[],c020:[],c021:[],c022:[],c023:[],c024:[],c025:[],c026:[],c027:[],c028:[],
      c029:[],c030:[],c031:[],c032:[],c033:[],c034:[],c035:[],c036:[],c037:[],c038:[],c039:[],c040:[],c041:[],c042:[],
      c043:[],c044:[],c045:[],c046:[],c047:[],c048:[],c049:[],c050:[],c051:[],c052:[],c053:[],c054:[],c055:[],c056:[],
      c057:[],c058:[],c059:[],c060:[],c061:[],c062:[],c063:[],c064:[],c065:[],c066:[],c067:[],c068:[],c069:[],c070:[],
      c071:[],c072:[],c073:[],c074:[],c075:[],c076:[],c077:[],c078:[],c079:[],c080:[],c081:[],c082:[],c083:[],c084:[],
      c085:[],c086:[],c087:[],c088:[],c089:[],c090:[],c091:[],c092:[],c093:[],c094:[],c095:[],c096:[],c097:[],c098:[],
      c099:[],c100:[],c101:[],c102:[],c103:[],c104:[],c105:[],c106:[],c107:[],c108:[],c109:[],c110:[],c111:[],c112:[],
      c113:[],c114:[],c115:[],c116:[],c117:[],c118:[],c119:[],c120:[],c121:[],c122:[],c123:[],c124:[],c125:[],c126:[],
      c127:[],c128:[],c129:[],c130:[],c131:[],c132:[],c133:[],c134:[],c135:[],c136:[],c137:[],c138:[],c139:[],c140:[],
      c141:[],c142:[],c143:[],c144:[],c145:[],c146:[],c147:[],c148:[],c149:[],c150:[],c151:[],c152:[],c153:[],c154:[],
      c155:[],c156:[],c157:[],c158:[],c159:[],c160:[],c161:[],c162:[],c163:[],c164:[],c165:[],c166:[],c167:[],c168:[],
      c169:[],c170:[],c171:[],c172:[],c173:[],c174:[],c175:[],c176:[],c177:[],c178:[],c179:[],c180:[],c181:[],c182:[],
      c183:[],c184:[],c185:[],c186:[],c187:[],c188:[],c189:[],c190:[],c191:[],c192:[],c193:[]
    },
    d: {
      d01: ["d01a", "d01b", "d01c"],
      d02: ["d02a", "d02b", "d02c", "d02d", "d02e", "d02f", "d02g", "d02h"],
      d03: ["d03a", "d03b", "d03c", "d03d", "d03e"],
      d04: ["d04a", "d04b", "d04c", "d04d", "d04e", "d04f", "d04g"],
      d05: [],
      d06: [],
      d07: [],
      d08: [],
      d09: [],
      d10:["d10a","d10b","d10c","d10d"],
      d11:[],
      d12:[]
    },
    e: {
      e01:[],e02:[],e03:[],e04:[],e05:[],e06:[],e07:[],e08:[],e09:[],e10:[],e11:[],e12:[]
    }
  },
  current: [],
  initial: ['a', 'b', 'c', 'd'],
  initial2: ['a', 'b', 'c', 'd', 'e'],
  open: "",
  cList: [],
  videoList: null,
  mode: 0,
  newMode: 1,
  title: "",
  inSearch: true,
  error: "",
  map: {
    a: "部位",
    a01: "面部",
    a02: "下颌",
    a03: "呼吸",
    a04: "颈",
    a05: "肩",
    a06: "肘",
    a07: "腕",
    a08: "手",
    a09: "胸椎",
    a10: "腰椎",
    a11: "髋",
    a12: "膝",
    a13: "踝",
    a14: "脚",
    a15: "核心",
    a16: "神经滑行术",
    a17: "平衡",
    a18: "刺猬球",
    a19: "泡沫辊",
    a20: "哑铃",
    a21: "弹力带",
    a22: "瑞士球",
    a01a: "全部",
    a01b: "辅助训练",
    a01c: "建议",
    a02a: "全部",
    a02b: "强化",
    a02c: "建议",
    a03a: "全部",
    a03b: "建议",
    a04a: "全部",
    a04b: "屈",
    a04c: "伸",
    a04d: "前伸",
    a04e: "回收",
    a04f: "旋转",
    a04g: "侧屈",
    a04h: "稳定性",
    a04i: "神经",
    a04j: "动眼神经",
    a04k: "姿势",
    a04l: "强化",
    a04m: "抻拉",
    a04n: "其他",
    a04o: "建议",
    a05a: "全部",
    a05b: "屈",
    a05c: "伸",
    a05d: "外展",
    a05e: "内收",
    a05f: "环转",
    a05g: "外旋",
    a05h: "内旋",
    a05i: "前伸",
    a05j: "回收",
    a05k: "姿势",
    a05l: "稳定性",
    a05m: "强化",
    a05n: "抻拉",
    a05o: "哑铃",
    a05p: "弹力带",
    a05q: "瑞士球",
    a05r: "其他",
    a05s: "建议",
    a06a: "全部",
    a06b: "屈",
    a06c: "伸",
    a06d: "旋前旋后",
    a06e: "本体感觉",
    a06f: "强化",
    a06g: "抻拉",
    a06h: "哑铃",
    a06i: "弹力带",
    a06j: "建议",
    a07a: "全部",
    a07b: "离心运动",
    a07c: "屈",
    a07d: "伸",
    a07e: "强化",
    a07f: "哑铃",
    a07g: "弹力带",
    a07h: "抻拉",
    a07i: "建议",
    a08a: "全部",
    a08b: "外展",
    a08c: "内收",
    a08d: "屈",
    a08e: "伸",
    a08f: "强化",
    a08g: "弹力带",
    a08h: "拇指离心训练",
    a08i: "抻拉",
    a08j: "建议",
    a09a: "全部",
    a09b: "屈",
    a09c: "伸",
    a09d: "旋转",
    a09e: "侧屈",
    a09f: "姿势",
    a09g: "抻拉",
    a09h: "瑞士球",
    a09i: "建议",
    a10a: "全部",
    a10b: "屈",
    a10c: "伸",
    a10d: "旋转",
    a10e: "侧屈",
    a10f: "核心",
    a10g: "姿势",
    a10h: "稳定性",
    a10i: "强化",
    a10j: "抻拉",
    a10k: "牵引",
    a10l: "瑞士球",
    a10m: "建议",
    a11a: "全部",
    a11b: "屈",
    a11c: "伸",
    a11d: "外展",
    a11e: "环转",
    a11f: "外旋",
    a11g: "内旋",
    a11h: "强化",
    a11i: "抻拉",
    a11j: "弹力带",
    a11k: "其他",
    a11l: "建议",
    a12a: "全部",
    a12b: "屈",
    a12m: "伸",
    a12c: "本体感觉",
    a12d: "协调能力",
    a12e: "强化",
    a12f: "抻拉",
    a12g: "弹力带",
    a12h: "泡沫辊",
    a12i: "瑞士球",
    a12j: "股内侧斜肌",
    a12k: "其他",
    a12l: "建议",
    a13a: "全部",
    a13b: "跖屈",
    a13c: "背屈",
    a13d: "内翻",
    a13e: "外翻",
    a13f: "本体感觉",
    a13g: "抻拉",
    a13h: "弹力带",
    a13i: "其他",
    a13j: "建议",
    a14a: "全部",
    a14b: "屈",
    a14c: "伸",
    a14d: "外展",
    a14e: "内收",
    a14f: "强化",
    a14g: "抻拉",
    a14h: "建议",
    a15a: "全部",
    a15b: "瑞士球",
    a15c: "其他",
    a15d: "建议",
    a16a: "全部",
    a16b: "正中神经",
    a16c: "尺神经",
    a16d: "桡神经",
    a16e: "坐骨神经",
    a16f: "股神经",
    a16g: "腓神经",
    a17a: "全部",
    a18a: "全部",
    a18b: "颈",
    a18c: "臂",
    a18d: "胸",
    a18e: "腰",
    a18f: "腿",
    a19a: "全部",
    a20a: "全部",
    a21a: "全部",
    a22a: "全部",
    b: "病症",
    b001: "阿基里斯腱（跟腱）病变",
    b002: "肩锁关节（ACJ）骨关节炎",
    b003: "肩锁关节（ACJ）脱位",
    b004: "肩锁关节（ACJ）扭伤",
    b005: "内收肌（腹股沟）拉伤",
    b006: "内收肌（腹股沟）撕裂",
    b007: "内收肌肌腱病变",
    b008: "踝关节扭伤",
    b009: "强直性脊柱炎",
    b010: "鹅足滑囊炎",
    b011: "前室综合征-下肢",
    b012: "前交叉韧带（ACL）损伤",
    b013: "前交叉韧带断裂/重建",
    b014: "前斜角肌综合征",
    b015: "哮喘",
    b016: "贝克囊肿（腘窝囊肿）",
    b017: "面神经麻痹（面瘫）",
    b018: "贝内特骨折",
    b019: "肱二头肌肌腱病变",
    b020: "股二头肌拉伤/撕裂",
    b021: "股二头肌肌腱病变",
    b022: "肘部二头肌肌腱撕裂",
    b023: "肩部二头肌肌腱撕裂",
    b024: "二头肌腱炎",
    b025: "布朗特病（弓形腿）",
    b026: "指关节钮孔状畸形",
    b027: "保龄球拇指",
    b028: "臂丛损伤",
    b029: "拇囊炎",
    b030: "臂丛神经病（死臂综合征）",
    b031: "大腿灼痛 (感觉异常性股痛症 伯恩哈特病)",
    b032: "肩部钙化性肌腱病变",
    b033: "腕骨骨折",
    b034: "腕管综合征（CTS）",
    b035: "马尾综合征",
    b036: "颈椎间盘突出症",
    b037: "颈椎脱位",
    b038: "颈椎小关节扭伤",
    b039: "颈椎骨折",
    b040: "颈椎骨关节炎",
    b041: "神经根型颈椎病（神经压迫）",
    b042: "颈椎病",
    b043: "脊髓型颈椎病（脊髓压迫）",
    b044: "髌骨软化症",
    b045: "髌骨软骨缺损",
    b046: "髌骨软骨软化症",
    b047: "锁骨骨折",
    b048: "尾骨痛",
    b049: "尾骨骨折",
    b050: "克雷氏骨折",
    b051: "腓总神经卡压症",
    b052: "室间隔综合征",
    b053: "脑震荡",
    b054: "先天性髋关节脱位",
    b055: "先天性肌性斜颈",
    b056: "先天性脊柱侧凸",
    b057: "肋软骨炎",
    b058: "肋椎关节紊乱",
    b059: "肋椎关节固定 ",
    b060: "肋椎关节扭伤",
    b061: "肘管综合征",
    b062: "尺骨神经病变（自行车手握把麻痹）",
    b063: "桡骨茎突狭窄性腱鞘炎",
    b064: "退行性椎间盘病",
    b065: "退行性椎间盘病（DDD）",
    b066: "发育性髋关节发育不良（髋脱位）（DDH）",
    b067: "弥漫性特发性骨质增生症 (DISH)",
    b068: "椎间盘突出症",
    b069: "椎间盘突出（椎间盘膨出/脱垂）",
    b070: "盘状半月板",
    b071: "桡骨远端骨折",
    b072: "掌腱膜挛缩症",
    b073: "肘部（鹰嘴）滑囊炎",
    b074: "肘部（鹰嘴）骨折",
    b075: "肘关节脱位骨折",
    b076: "肘部扭伤",
    b077: "内生软骨瘤",
    b078: "尺侧腕伸肌（ECU）肌腱炎",
    b079: "指伸肌肌腱损伤",
    b080: "伸肌腱断裂",
    b081: "小关节骨性关节炎",
    b082: "小关节综合征",
    b083: "面神经麻痹",
    b084: "髌下脂肪垫撞击症",
    b085: "股骨前倾",
    b086: "股骨骨折",
    b087: "股神经压迫",
    b088: "手指脱位",
    b089: "手指伸肌腱损伤",
    b090: "手指骨折",
    b091: "近端指间关节脱位",
    b092: "手指扭伤",
    b093: "指尖损伤/截肢",
    b094: "椎骨小关节固定",
    b095: "屈指肌腱损伤",
    b096: "局灶性肌张力障碍",
    b097: "预防跌倒骨折",
    b098: "全髋关节置换术后股骨骨折",
    b099: "冻结肩",
    b100: "加莱阿齐骨折",
    b101: "守门员拇指",
    b102: "腱鞘囊肿",
    b103: "腓肠肌（小腿）拉伤/撕裂",
    b104: "腓肠肌肌腱病变",
    b105: "运动型疝",
    b106: "肩关节内旋障碍 (GIRD)",
    b107: "肩关节不稳",
    b108: "肩关节骨性关节炎",
    b109: "肩关节盂唇撕裂",
    b110: "臀肌劳损",
    b111: "臀中肌腱病变",
    b112: "高尔夫球手肘部（内侧上髁炎）",
    b113: "痛风",
    b114: "桡骨远端青枝骨折",
    b115: "腹股沟拉伤",
    b116: "尺管综合征",
    b117: "腘绳肌拉伤",
    b118: "腘绳肌末端肌腱炎",
    b119: "腘绳肌断裂",
    b120: "手部骨折/脱位",
    b121: "手部骨关节炎 ",
    b122: "头痛",
    b123: "颈椎间盘突出",
    b124: "腰椎间盘突出",
    b125: "髋关节内收肌拉伤",
    b126: "髋关节缺血性坏死",
    b127: "髋关节滑囊炎",
    b128: "髋关节脱位",
    b129: "髂腰肌损伤",
    b130: "髋部骨折",
    b131: "髋关节撞击综合征",
    b132: "髋关节盂唇撕裂",
    b133: "髋关节炎",
    b134: "髋骨隆凸挫伤",
    b135: "髋关节置换",
    b136: "髋关节损伤",
    b137: "膝关节脂肪垫刺激征（霍法氏综合征）",
    b138: "钩骨钩骨折",
    b139: "肱骨骨折",
    b140: "膝过伸",
    b141: "脊柱后凸",
    b142: "脊柱前凸",
    b143: "髂腰肌综合征",
    b144: "髂胫束综合征",
    b145: "肩峰下撞击综合征",
    b146: "髋关节炎",
    b147: "肋间肌拉伤",
    b148: "胫骨内扭转",
    b149: "指间关节脱位",
    b150: "指间关节扭伤",
    b151: "交叉综合征",
    b152: "内八字步态",
    b153: "坐骨滑囊炎",
    b154: "球衣指",
    b155: "跳跃膝",
    b156: "月骨无菌性坏死（月骨软化症、金伯克氏病）",
    b157: "膝关节前交叉韧带损伤 ACL",
    b158: "膝关节镜术后",
    b159: "髌骨挫伤",
    b160: "膝关节侧副韧带损伤",
    b161: "膝内侧副韧带断裂",
    b162: "膝内侧副韧带扭伤",
    b163: "膝骨关节炎",
    b164: "膝关节置换",
    b165: "膝扭伤",
    b166: "腰椎椎板切除术",
    b167: "侧副韧带扭伤",
    b168: "长短腿",
    b169: "股骨头骨骺骨软骨病",
    b170: "肩胛提肌综合征",
    b171: "胸长神经麻痹",
    b172: "下腰痛（下背痛）",
    b173: "下交叉综合症",
    b174: "腰椎间盘突出",
    b175: "神经根型腰椎病",
    b176: "腰椎管狭窄症",
    b177: "腰椎应力性骨折",
    b178: "棒球指",
    b179: "颌鼻甲骨",
    b180: "膝内侧韧带扭伤",
    b181: "胫骨内侧应力综合征",
    b182: "儿童肱骨内上髁炎",
    b183: "半月板撕裂",
    b184: "掌骨骨折",
    b185: "偏头痛",
    b186: "颈部骨折",
    b187: "颈痛",
    b188: "颈扭伤",
    b189: "非特异性下腰痛",
    b190: "骨结节骨骺炎 （奥斯古德病）",
    b191: "骨软骨病",
    b192: "剥脱性骨软骨炎",
    b193: "骨软骨瘤",
    b194: "成骨肉瘤（骨肉瘤）",
    b195: "髋关节坏死",
    b196: "膝关节坏死",
    b197: "髌骨根尖炎",
    b198: "髌骨脱位",
    b199: "髌骨骨折",
    b200: "髌骨不稳定",
    b201: "髌腱病变",
    b202: "髌腱撕裂",
    b203: "髌骨跟踪障碍",
    b204: "髌股关节炎",
    b205: "髌股关节痛症候群",
    b206: "胸小肌综合征",
    b207: "腓神经压迫",
    b208: "腓骨肌腱病",
    b209: "手指骨损伤",
    b210: "手指骨骨折",
    b211: "梨状肌综合征",
    b212: "足底筋膜炎",
    b213: "皱襞综合征",
    b214: "腘窝滑囊炎",
    b215: "后交叉韧带（PCL）撕裂",
    b216: "骨间后神经压迫",
    b217: "胫骨后肌腱病变",
    b218: "胫后肌腱功能障碍",
    b219: "髌前滑囊炎",
    b220: "旋前肌综合征",
    b221: "旋前肌综合症",
    b222: "股四头肌拉伤",
    b223: "股四头肌肌腱病变",
    b224: "股四头肌肌腱撕裂",
    b225: "股四头肌肌腱炎",
    b226: "桡骨头骨折",
    b227: "桡管综合征",
    b228: "雷诺氏现象",
    b229: "拇指重复性使力伤害",
    b230: "手/腕重复性使力伤害",
    b231: "类风湿关节炎",
    b232: "肋骨挫伤",
    b233: "肋骨骨折",
    b234: "肩袖撕裂",
    b235: "肩袖肌腱病变",
    b236: "跑步膝",
    b237: "骶髂关节功能障碍",
    b238: "骶髂关节过度活动",
    b239: "骶髂关节骨关节炎",
    b240: "骶髂关节痛",
    b241: "腕舟状骨骨折",
    b242: "肩胛骨骨折",
    b243: "肩胛骨旋转功能障碍（SICK 肩胛骨）",
    b244: "坐骨神经痛",
    b245: "脊柱侧弯",
    b246: "儿童和青少年的脊柱侧弯",
    b247: "外胫夹",
    b248: "肩关节置换术",
    b249: "肩关节镜术后",
    b250: "肩部减压术后",
    b251: "肩关节脱位",
    b252: "肩关节骨折",
    b253: "脊柱融合术",
    b254: "脊柱感染",
    b255: "脊髓神经根压迫",
    b256: "椎管狭窄",
    b257: "脊柱肿瘤",
    b258: "脊柱小关节骨关节炎",
    b259: "脊椎滑脱症",
    b260: "椎弓峡部裂",
    b261: "骶骨椎弓峡部裂",
    b262: "胸骨骨折",
    b263: "脑卒中（中风）",
    b264: "肩峰下滑囊炎",
    b265: "天鹅颈样畸形",
    b266: "跗骨管综合征",
    b267: "颞下颌关节（TMJ）功能障碍",
    b268: "网球肘（外侧上髁炎）",
    b269: "网球肩",
    b270: "胸腰椎间关节扭伤",
    b271: "胸廓出口综合征",
    b272: "青少年棒球肘",
    b273: "拇指脱位",
    b274: "拇指骨折",
    b275: "拇指骨关节炎",
    b276: "胫骨腓骨骨折",
    b277: "胫骨平台骨折",
    b278: "胫骨假关节",
    b279: "胫骨干骨折",
    b280: "肋软骨炎（Tieze综合征）",
    b281: "斜颈",
    b282: "髋关节暂时性骨质疏松症",
    b283: "横突骨折",
    b284: "特伦德伦堡步态",
    b285: "肱三头肌劳损",
    b286: "肱三头肌肌腱病变",
    b287: "肱三头肌肌腱撕裂",
    b288: "肱三头肌肌腱断裂",
    b289: "扳机指",
    b290: "大粗隆滑囊炎",
    b291: "尺骨（远端）骨折",
    b292: "尺骨（近端）骨折",
    b293: "尺侧副韧带撕裂",
    b294: "肘部尺神经压迫",
    b295: "上交叉综合征",
    b296: "椎体挤压/压缩骨折",
    b297: "掌板损伤",
    b298: "挥鞭样损伤",
    b299: "手腕骨关节炎",
    b300: "腕扭伤",
    b301: "歪脖",
    b302: "眩晕",
    c: "肌肉",
    c001: "腹肌",
    c002: "小指展肌",
    c003: "小趾展肌",
    c004: "拇展肌",
    c005: "趾展肌",
    c006: "小趾展肌",
    c007: "小指（趾）展肌",
    c008: "拇短展肌",
    c009: "拇外展肌",
    c010: "内收短肌",
    c011: "内收拇趾肌",
    c012: "长收肌",
    c013: "大收肌",
    c014: "内收拇指肌",
    c015: "肘肌",
    c016: "三角肌前束",
    c017: "斜角肌前束",
    c018: "肱二头肌",
    c019: "股二头肌",
    c020: "肱肌",
    c021: "肱桡肌",
    c022: "颊肌",
    c023: "尾骨肌",
    c024: "喙肱肌",
    c025: "皱眉肌",
    c026: "三角肌",
    c027: "三角肌前束",
    c028: "三角肌中束",
    c029: "三角肌后束",
    c030: "降口角肌",
    c031: "降下唇肌",
    c032: "降鼻中隔",
    c033: "降眉肌",
    c034: "横膈",
    c035: "二腹肌",
    c036: "背侧骨间肌",
    c037: "竖脊肌",
    c038: "桡侧伸腕短肌",
    c039: "桡侧伸腕长肌",
    c040: "尺侧伸腕肌",
    c041: "小指伸肌",
    c042: "指伸肌",
    c043: "伸趾短肌",
    c044: "指总伸肌",
    c045: "伸趾长肌",
    c046: "拇短伸肌",
    c047: "伸姆长肌",
    c048: "伸食指肌",
    c049: "拇短伸肌",
    c050: "拇长伸肌",
    c051: "腹外斜肌",
    c052: "眼外肌",
    c053: "第一骨间背侧肌",
    c054: "桡侧屈腕肌",
    c055: "尺侧屈腕肌",
    c056: "屈小指肌",
    c057: "屈小趾短肌",
    c058: "屈趾短肌",
    c059: "屈趾长肌",
    c060: "屈指深肌",
    c061: "屈指浅肌",
    c062: "屈姆短肌",
    c063: "屈姆长肌",
    c064: "屈拇短肌",
    c065: "屈拇长肌",
    c066: "额肌",
    c067: "下籽肌",
    c068: "上籽肌",
    c069: "腓肠肌",
    c070: "颏舌肌",
    c071: "臀大肌",
    c072: "臀中肌",
    c073: "臀小",
    c074: "腘绳肌",
    c075: "舌骨舌肌",
    c076: "髂肌",
    c077: "颈髂肋肌",
    c078: "腰大肌",
    c079: "胸髂肋肌",
    c080: "髂腰肌",
    c081: "髂胫束",
    c082: "舌骨下肌",
    c083: "棘下肌",
    c084: "肋间肌",
    c085: "腹内斜肌",
    c086: "骨间肌",
    c087: "棘间肌",
    c088: "横突间肌",
    c089: "外翼肌",
    c090: "背阔肌",
    c091: "斜角肌",
    c092: "提肛肌",
    c093: "提上唇肌",
    c094: "提上唇鼻翼肌",
    c095: "上睑提肌",
    c096: "提肩胛肌",
    c097: "肋提肌",
    c098: "头最长肌",
    c099: "颈最长肌",
    c100: "胸最长肌",
    c101: "头长肌",
    c102: "颈长肌",
    c103: "蚓状肌",
    c104: "嚼肌",
    c105: "内翼肌",
    c106: "颏肌",
    c107: "多裂肌",
    c108: "鼻肌",
    c109: "头下斜肌",
    c110: "头上斜肌",
    c111: "闭孔外肌",
    c112: "闭孔内肌",
    c113: "枕额肌",
    c114: "枕肌",
    c115: "小指对掌肌",
    c116: "拇指对掌肌",
    c117: "拇长对掌肌",
    c118: "眼轮匝肌",
    c119: "口轮匝肌",
    c120: "舌腭肌",
    c121: "掌侧骨间肌",
    c122: "掌短肌",
    c123: "掌长肌",
    c124: "耻骨肌",
    c125: "胸大肌",
    c126: "胸小肌",
    c127: "盆底肌",
    c128: "腓骨短肌",
    c129: "腓骨长肌",
    c130: "梨状肌",
    c131: "足底筋膜",
    c132: "阔颈肌",
    c133: "腘肌",
    c134: "后斜角肌",
    c135: "降眉间肌",
    c136: "旋前方肌",
    c137: "旋前圆肌",
    c138: "腰大肌",
    c139: "翼状肌",
    c140: "股方肌",
    c141: "下唇方肌",
    c142: "上唇方肌",
    c143: "腰方肌",
    c144: "跖方肌",
    c145: "股四头肌",
    c146: "腹直肌",
    c147: "头前直肌",
    c148: "头外侧直肌",
    c149: "头后大直肌",
    c150: "头后小直肌",
    c151: "股直肌",
    c152: "菱形肌",
    c153: "笑肌",
    c154: "回旋肌",
    c155: "缝匠肌",
    c156: "斜角肌",
    c157: "半膜肌",
    c158: "头半棘肌",
    c159: "颈半棘肌",
    c160: "胸半棘肌",
    c161: "半腱肌",
    c162: "前锯肌",
    c163: "下后锯肌",
    c164: "比目鱼肌",
    c165: "头棘肌",
    c166: "颈棘肌",
    c167: "胸半棘肌",
    c168: "头夹肌",
    c169: "颈夹肌",
    c170: "胸锁乳突肌",
    c171: "茎舌肌",
    c172: "枕下肌",
    c173: "肩胛下肌",
    c174: "旋后肌",
    c175: "舌骨上肌",
    c176: "棘上肌",
    c177: "颞肌",
    c178: "阔筋膜张肌",
    c179: "大圆肌",
    c180: "小圆肌",
    c181: "胫前肌",
    c182: "横突棘肌",
    c183: "腹横肌",
    c184: "斜方肌",
    c185: "斜方肌下束",
    c186: "斜方肌中束",
    c187: "斜方肌上束",
    c188: "三角部",
    c189: "三头肌",
    c190: "肱三头肌",
    c191: "股内斜肌",
    c192: "颧大肌",
    c193: "颧小肌",
    d: "人群",
    d01: "产前普拉提",
    d02: "人体工程学",
    d03: "老年人防摔倒",
    d04: "中风",
    d05: "普拉提",
    d06: "产后康复",
    d07: "儿童康复",
    d08: "乳腺癌康复",
    d09: "减重",
    d10: "气功",
    d11: "有氧练习",
    d12: "营养",
    d01a: "全部",
    d01b: "盆底肌",
    d01c: "其他",
    d02a: "全部",
    d02b: "颈",
    d02c: "臂",
    d02d: "背",
    d02e: "腿",
    d02f: "姿势",
    d02g: "强化",
    d02h: "抻拉",
    d03a: "全部",
    d03b: "抗阻训练",
    d03c: "坐",
    d03d: "站",
    d03e: "走",
    d04a: "手腕",
    d04b: "肩肘",
    d04c: "脊柱",
    d04d: "腿",
    d04e: "面",
    d04f: "全身",
    d04g: "心理训练",
    d10a: "太极",
    d10b: "八段锦",
    d10c: "五禽戏",
    d10d: "导引",
    e: "物理治疗",
    e01: "电疗",
    e02: "光疗",
    e03: "超声疗法",
    e04: "磁疗法",
    e05: "冷热疗法",
    e06: "水疗法",
    e07: "中医",
    e08: "心理疗法",
    e09: "手法",
    e10: "牵引",
    e11: "按摩",
    e12: "中医按摩"
  },
  chosen: ""
}

const categoryClick = (state, action) => {
  const newCurrent = state.overallInfo[action.name]
  let updated = Object.keys(newCurrent).sort()
  return updateObject(state, {
    inside: state.current[action.index],
    current: updated,
    unchangedCurrent: [...updated],
    root: false,
    bcSearch: ""
  })
}

const bcSearchChange = (state, action) => {

  if (action.value === "") {
    const updated = [...state.unchangedCurrent]
    return updateObject(state, {current: updated, bcSearch: action.value})
  } else {
    const updated = state.unchangedCurrent.filter(id => state.map[id].includes(action.value))
    return updateObject(state, {current: [...updated], bcSearch: action.value})
  }
}

const backClick = (state, action) => {
  return updateObject(state, {
    inside: "",
    current: [...state.initial2],
    root: true,
    open: "",
    cList: []
  })

}

const dropDown = (state, action) => {
  if (state.cList.length > 0 && state.open === action.name) {
    return updateObject(state, {cList: [], open: ""})
  } else {
    let newCList = [...state.overallInfo[action.inside][action.name]]
    return updateObject(state, {cList: newCList, open: action.name})
  }
}

const searchMovesStart = (state, action) => updateObject(state, {
  mode: 1,
  chosen: action.c === 0 ? action.b : action.c
})

const searchMovesFail = (state, action) => updateObject(state, {mode: 2, error: action.error})

const searchMovesSuccess = (state, action) => {
  // console.log(action.videoList)
  // const a = [...action.videoList]
  // a.sort((a,b) => a.id-b.id)
  // console.log(a)

  if (window.innerWidth < 780) {
    return {...initialState, current: [...initialState.initial2], newMode: 1,
      inSearch: true, mode: 0, videoList: action.videoList.sort((a,b) => a.id-b.id), title: action.title}
  } else {
    return updateObject(state,
      {inSearch: true, mode: 0, videoList: action.videoList.sort((a,b) => a.id-b.id), title: action.title})
  }
}

const categoriesInit = () => {
  return {...initialState, current: [...initialState.initial2], newMode: 1, chosen: ""}
}

const searchAllSuccess = (state, action) => updateObject(state,
  {inSearch: false, mode: 0, videoList: action.list, title: "全部视频中搜索"+action.first5.join(",")})

const searchChosenVideosSuccess = (state, action) => {
  return updateObject(state,
    {inSearch: false, mode: 0, videoList: [...action.finalMoves], title: "已选动作"})
}

const searchAllStart = state => updateObject(state, {mode: 1})


const reducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.CATEGORY_CLICK:
      return categoryClick(state, action)
    case actionTypes.BACK_CLICK:
      return backClick(state, action)
    case actionTypes.DROP_DOWN:
      return dropDown(state, action)
    case actionTypes.SEARCH_MOVES_START:
      return searchMovesStart(state, action)
    case actionTypes.SEARCH_MOVES_FAIL:
      return searchMovesFail(state, action)
    case actionTypes.SEARCH_MOVES_SUCCESS:
      return searchMovesSuccess(state, action)
    case actionTypes.CATEGORIES_INIT:
      return categoriesInit(state, action)
    case actionTypes.SEARCH_ALL_SUCCESS:
      return searchAllSuccess(state, action)
    case actionTypes.SEARCH_CHOSEN_VIDEOS_SUCCESS:
      return searchChosenVideosSuccess(state, action)
    case actionTypes.SEARCH_CHOSEN_VIDEOS_FAIL:
      return searchMovesFail(state, action)
    case actionTypes.SEARCH_ALL_START:
      return searchAllStart(state, action)
    case actionTypes.BC_SEARCH_CHANGE:
      return bcSearchChange(state, action)
    default: return state
  }
}

export default reducer


// WEBPACK FOOTER //
// ./src/store/reducers/categories.js